export default __webpack_public_path__ + "static/media/Comp 2_00001.827d93ae.png";